import gql from 'graphql-tag';
import PRODUCT_FRAGMENT from 'graph/fragments/product';

const GET_ORGANIZATION_STATS = gql`
  query getOrganizationStats($id: Int!) {
    organization(where: { id: $id }) {
      id
      type
      name
      licenseUsage {
        assignedCount
        classroomAssignedCount
        product {
          ...BaseProduct
        }
      }
      stats {
        classroomStudentCount
        userCount
        classroomCount
      }
      parentOrganization {
        id
        name
      }
      subOrganizations {
        id
        name
        type
      }
    }
  }
  ${PRODUCT_FRAGMENT}
`;

export default GET_ORGANIZATION_STATS;
